// extracted by mini-css-extract-plugin
module.exports = {"iconButtonSpinner":"previewButton_iconButtonSpinner__UC3q9","previewButton":"previewButton_previewButton__6AoJy"};